import { render, staticRenderFns } from "./SettingsElement.vue?vue&type=template&id=5376b56a&"
import script from "./SettingsElement.vue?vue&type=script&lang=js&"
export * from "./SettingsElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports